import React from 'react'

const Foot = () => {
  return (
    // <Footer
    //   className="transparent"
    //   copyrights="&copy 2015 Copyright Text"
    //   links={<ul><li><a className="grey-text text-lighten-3" href="#!">Link 1</a></li><li><a className="grey-text text-lighten-3" href="#!">Link 2</a></li><li><a className="grey-text text-lighten-3" href="#!">Link 3</a></li><li><a className="grey-text text-lighten-3" href="#!">Link 4</a></li></ul>}
    // >
    //   <div className="col s10">
    //     <h5 className="white-text"> WelfareX India Private Limited</h5>
    //     <p  className="white-text"> At  WelfareX, we are commited to provide exceptional quality professional and compassionate home care services to all of our clients</p>
    //     <span className="row green lighten-3 black-text"> Contact No: +918100565773</span>
    //   </div>

    // </Footer>
    <footer className="page-footer container grey darken-3">
      <div className="row">
        <div className="col l5 s12 offset-l1">
           <h5 className="white-text"> WelfareX India Private Limited</h5>
         <p  className="white-text"> At  WelfareX, we are commited to provide exceptional quality professional and compassionate home care services to all of our clients</p>
        </div>
        <div className="col l5 s12">
          <h5 className="white-text"> Contact </h5>
          <ul>
            <li> <i className="material-icons">add_location</i> <span> Address: 104 Sec B Metropolitan Coop Hsg Soc, Kolkata 700105 </span></li>
            <li> <i className="material-icons">call</i>  <span> Contact No: +91 81005 65773 </span> </li>
          </ul>
        </div>
      </div>
    </footer>
  )
}

export default Foot